/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import { reduxForm, initialize } from 'redux-form'
import { createSelector } from 'reselect'
import _get from 'lodash/get'
import { analytics, SITE_SECTIONS } from 'services/Analytics'
import { ALERTS } from 'constants/alerts'
import { USER_FORMS } from 'constants/forms'
import { EMPTY_OBJECT } from 'constants/frozenObjects'
import { withLocalization } from 'hocs/localization'
import { updateBusinessDetails } from 'api/client/actions/business'
import { getUserDetails as onGetUserDetails } from 'api/client/actions/user'
import { onShowError, createAlert } from 'redux-app/modules/alerts'
import { getUserDetails, isUserUnableToUpdateInfo } from 'redux-app/selectors/user'
import { getErrorCodes } from 'utils/error'
import BusinessDetailsForm from './BusinessDetailsForm'

const FORM_NAME = USER_FORMS.profileBusinessDetails

const getInitialValues = createSelector(
  state => _get(getUserDetails(state), 'company', EMPTY_OBJECT),
  (state, props) => props.isEdit,
  (company, isEdit) => {
    if (isEdit) {
      return company
    }
  },
)

export default compose(
  connect(
    (state, props) => ({
      initialValues: getInitialValues(state, props),
      isUserUnableToUpdateInfo: isUserUnableToUpdateInfo(state),
    }),
    {
      onShowError,
      createAlert,
      initialize,
      updateBusinessDetails,
      onGetUserDetails,
    },
  ),
  withLocalization('profile.create.business'),
  withHandlers({
    onSubmit: ({
     updateBusinessDetails,
     onShowError,
     createAlert,
     onGetUserDetails,
    }) => formValues => {
      return updateBusinessDetails({ company: formValues })
        .then(({ value: { result } }) => {
          createAlert({ name: ALERTS.successBusinessDetailsChanged })
          analytics.saveChanges({ sectionName: SITE_SECTIONS.businessDetails })
          onGetUserDetails()
        })
        .catch((error: Error) => {
          analytics.showMyAccountError({
            errorCodes: getErrorCodes(error),
            sectionType: SITE_SECTIONS.businessDetails,
          })
          onShowError(error, formValues)
        })
    },
  }),
  reduxForm({
    form: FORM_NAME,
    enableReinitialize: true,
  }),
)(BusinessDetailsForm)
